/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "business": {
            "nested": {
              "service": {
                "nested": {
                  "GetAccountTransferEligibilityResponse": {
                    "nested": {
                      "TransferIneligibleReason": {
                        "values": {
                          "TIR_DO_NOT_USE": 0,
                          "FLEX_LOAN": 1,
                          "CREDIT_CARD": 2,
                          "PPP_LOAN": 3,
                          "PARTNER_LOAN": 4,
                          "TERM_LOAN": 5,
                          "MCA_LOAN": 6,
                          "HARDWARE_FINANCING": 7,
                          "GAP_LOAN": 8,
                          "PLAID_ACCOUNT_LINKAGE": 9,
                          "OTHER_APPLICATION_INFORMATION": 10,
                          "MCA_GLOBAL_LOAN": 11,
                          "BLENDED_LOAN": 12,
                          "LINE_OF_CREDIT": 13,
                          "MULTIDRAW_FLEX": 14
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.business?.nested?.service?.nested?.GetAccountTransferEligibilityResponse?.nested?.TransferIneligibleReason) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetAccountTransferEligibilityResponse @ squareup/capital/business/service.proto at 486:1
 */
export const GetAccountTransferEligibilityResponse = {};
/**
 * SOURCE TransferIneligibleReason @ squareup/capital/business/service.proto at 487:3
 */
GetAccountTransferEligibilityResponse.TransferIneligibleReason = $root.lookupEnum('squareup.capital.business.service.GetAccountTransferEligibilityResponse.TransferIneligibleReason').values;